import { TimezoneHelper } from '@shared/helpers';
import { FeeWaiverDateInterval, FeeWaiverTypeEnum } from '@shared/types/waivers';
import { FeeWaiverDatesHelper } from './fee-waiver-dates.helper';

const FEE_WAIVERS_COLORS = {
    PRESET: '#a8dfab',
    AUTOMATED_EDITABLE: '#fddb98',
    AUTOMATED_NON_EDITABLE: '#f6b3b0',
    MANUALLY_ADDED: '#c3d6f5',
};

function getFeeWaiverTagColor(feeWaiverType: FeeWaiverTypeEnum) {
    switch (feeWaiverType) {
        case FeeWaiverTypeEnum.PRESET:
            return FEE_WAIVERS_COLORS.PRESET;
        case FeeWaiverTypeEnum.AUTOMATED_EDITABLE:
            return FEE_WAIVERS_COLORS.AUTOMATED_EDITABLE;
        case FeeWaiverTypeEnum.AUTOMATED_NON_EDITABLE:
            return FEE_WAIVERS_COLORS.AUTOMATED_NON_EDITABLE;
        case FeeWaiverTypeEnum.MANUALLY_ADDED:
            return FEE_WAIVERS_COLORS.MANUALLY_ADDED;
    }
}

const FEE_WAIVER_PERIOD_INFO_I18N = {
    SINGLE_MONTH: 'group.feeWaivers.manageWaivers.periodInfoSingleMonth',
    SINGLE_MONTH_BULK_EDIT: 'group.feeWaivers.manageWaivers.periodInfoSingleMonthBulk',
    RANGE: 'group.feeWaivers.manageWaivers.periodInfo',
} as const;

function getFeeWaiverIntervalPeriodInfoTranslation(
    interval: FeeWaiverDateInterval,
    isBulkEdit = false
): {
    key: (typeof FEE_WAIVER_PERIOD_INFO_I18N)[keyof typeof FEE_WAIVER_PERIOD_INFO_I18N];
    params: { month: string } | { start: string; end: string; count: number };
} {
    if (interval.count === 1) {
        return {
            key: isBulkEdit
                ? FEE_WAIVER_PERIOD_INFO_I18N.SINGLE_MONTH_BULK_EDIT
                : FEE_WAIVER_PERIOD_INFO_I18N.SINGLE_MONTH,
            params: { month: interval.startMonthYear },
        };
    }

    return {
        key: FEE_WAIVER_PERIOD_INFO_I18N.RANGE,
        params: {
            start: interval.startMonthYear,
            end: interval.endMonthYear,
            count: interval.count,
        },
    };
}

function checkIfWaiverCanBeEditable(type: FeeWaiverTypeEnum): boolean {
    return (
        type === FeeWaiverTypeEnum.PRESET ||
        type === FeeWaiverTypeEnum.AUTOMATED_EDITABLE ||
        type === FeeWaiverTypeEnum.MANUALLY_ADDED
    );
}

function checkIfActiveWaiverCanBeDeleted(startDate: string): boolean {
    const currentMonth = TimezoneHelper.firstDayOfCurrentUTCMonth();
    const sD = FeeWaiverDatesHelper.readResponseStartDate(startDate);
    return currentMonth.getFullYear() === sD.getFullYear() && currentMonth.getMonth() === sD.getMonth();
}

export const WaiversHelper = {
    FEE_WAIVERS_COLORS,
    FEE_WAIVER_PERIOD_INFO_I18N,
    getFeeWaiverTagColor,
    getFeeWaiverIntervalPeriodInfoTranslation,
    checkIfWaiverCanBeEditable,
    checkIfActiveWaiverCanBeDeleted,
};
